(function () {
  function patch() {
    var Ctor = window.customElements.get('shape-swatch');
    if (!Ctor || !Ctor.prototype) return;
    Ctor.prototype.isGradient = function () {
      return false;
    };
    document.querySelectorAll('shape-swatch').forEach(function (el) {
      if (typeof el.setValue === 'function') el.setValue();
    });
  }
  if (window.customElements && window.customElements.get('shape-swatch')) {
    patch();
  } else if (window.customElements) {
    window.customElements.whenDefined('shape-swatch').then(patch);
  }
})();

(function () {
  function guardHeader(el) {
    if (!el || el.__hortenceNavGuarded) return;
    if (typeof el.checkIsNavContainerFitAllLinks !== 'function') return;
    el.__hortenceNavGuarded = true;
    var original = el.checkIsNavContainerFitAllLinks;
    var callTimes = [];
    el.checkIsNavContainerFitAllLinks = function () {
      var now = Date.now();
      callTimes.push(now);
      callTimes = callTimes.filter(function (t) {
        return now - t < 1000;
      });
      if (callTimes.length > 6) {
        return;
      }
      return original.apply(el, arguments);
    };
  }
  function scan() {
    document.querySelectorAll('header-component').forEach(guardHeader);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
})();

(function () {
  window.addEventListener('wheel', function (e) {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX) * 1.2) {
      e.stopImmediatePropagation();
    }
  }, { capture: true, passive: true });
})();
